import React from 'react';
import { SettingsIcon, ShieldCheckIcon } from 'lucide-react';
export function YourAccess() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-2830">
      <div className="max-w-4xl mx-auto px-4 md:px-8 pt-8" data-id="element-2831">
        <div className="flex items-center gap-3 mb-4" data-id="element-2832">
          <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{
          backgroundColor: 'rgba(30,61,47,0.08)'
        }} data-id="element-2833">
            <SettingsIcon size={20} style={{
            color: '#1e3d2f'
          }} data-id="element-2834" />
          </div>
          <h2 className="text-2xl md:text-3xl font-bold uppercase" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-2835">
            Your Access to and Control Over Information
          </h2>
        </div>
        <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border" style={{
        borderColor: '#ede9e0'
      }} data-id="element-2836">
          <p className="text-base text-gray-800 leading-relaxed mb-4" style={{
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-2837">
            You may opt out of any future contacts from us at any time. You can
            do the following at any time by contacting us via the email address
            or phone number given on our website:
          </p>
          <ul className="space-y-3" data-id="element-2838">
            {['See what data we have about you, if any.', 'Change/correct any data we have about you.', 'Have us delete any data we have about you.', 'Express any concern you have about our use of your data.'].map(item => <li key={item} className="flex items-start gap-3" data-id="element-2839">
                <ShieldCheckIcon size={18} className="flex-shrink-0 mt-0.5" style={{
              color: '#1e3d2f'
            }} data-id="element-2840" />
                <span className="text-base text-gray-800" style={{
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-2841">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </div>;
}